export default __webpack_public_path__ + "static/media/sou.f3d04aac.svg";